import useAcl from './useAcl';

export default useAcl;
